<figure class="cargosprint-logo cargosprint-logo--{{size()}} cargosprint-logo--{{orientation()}}">
    <img [src]="logoPath()" alt="CargoSprint logo" title="CargoSprint logo" draggable="false">
</figure>
